
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';
    import descripcion from './resumen-descripcion.vue';
    import bsas from './padron-buenos-aires.vue';
    import caba from './padron-caba.vue';
    import { Wait } from '@/__env/ext';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            descripcion,
            caba,
            bsas,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Mensajes() { return this.Controlador.Mensajes; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {

            //await Wait( 500 );
            //this.Panel = -1;

            this.Eventos.push( this.Controlador.Vista.onEstado.subscribe( () =>
            {
                //if ( this.Estado == 'iniciado' )


            } ) );
        }

        public Panel: number = null;
        public Refresh: boolean = true;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
